"use client";

import { useState } from "react";
import { Contents } from '@/@types';
import Image from 'next/image';
import { getEmbedUrl } from "@/helpers/media/getEmbedUrl";
import ModalVideoMedia from "@/components/ui/Modals/ModalVideoMedia";

type ProductProps = {
    documents: Contents[],
};

export default function ProductTabDocuments({ documents }: ProductProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [titleVideo, setTitleVideo] = useState<string | null>(null);

    const openModalWithVideo = (titleVideo: string, url: string) => {
        const embedUrl = getEmbedUrl(url);
        setVideoUrl(embedUrl);
        setIsModalOpen(true);
        setTitleVideo(titleVideo);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setVideoUrl(null);
        setTitleVideo(null);
    };

    return (
        <div className="bg-light00 ">
            <div>
                <ul className="grid grid-cols-1 lg:grid-cols-2 text-sm text-dark02">
                    {documents && documents.length > 0 ? (
                        documents.map((document: Contents, index: number) => (
                            <li className="border-b pl-4 pr-4 pt-2 pb-2 gap-4" key={index}>
                                <a href={document.local || document.media_url || ''} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between">
                                    <span className="font-medium">{document.title ?? ''}</span>
                                    <button className="p-2 bg-light01 rounded-md cursor-pointer">
                                        <Image src="/download.svg" alt="Descargar" width={20} height={20} className='w-4 h-4' />
                                    </button>
                                </a>
                            </li>
                        ))
                    ) : (
                        <li className="pl-4 pr-4 pt-2 pb-2 text-center font-bold">Sin información de documentos</li>
                    )}
                </ul>
            </div>
        </div >
    )
}
